/**
 * Evalutor for view condition "custom_code"
 * @module
 */

var Exec = require('core/exec');
var CUSTOM_CODE = 'custom_code';

var pluginViewMatcherCustom = {
  // Calling this "match" doesn't make any sense, except that that's the interface the View module is already using.
  match: function(viewTicket, condition) {
    // TODO: Pass viewTicket to exec?
    return Exec.apply(condition.value);
  },
};

module.exports = function(PluginManager) {
  PluginManager.registerViewMatcher(CUSTOM_CODE, pluginViewMatcherCustom);
};

if (__TEST__) {
  module.exports.plugin = pluginViewMatcherCustom;
}
